import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose';
import { withRouter } from 'react-router-dom'
import { fetchUsers } from '../store/actions/users';
import { authRedirect } from '../lib/utils';
import UserList from '../components/userList';
import { withLoadingComponent, withErrorComponent } from '../components/loading';

const mapStateToProps = (state, ownProps) => {
    return {
        ...state.users,
        ...state.searchKey,
        ...state.paging,
        onCreateUserClick: () => {
            ownProps.history.push(`/users/new`)
        },
        openUser: (index) => {
            let user = state.users.users[index];
            ownProps.history.push(`/users/${user.id}`)
        }
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        fetchUsers: (key, page) => dispatch(fetchUsers(key, page)).catch(authRedirect(ownProps))
    }
};

const lifecycleValue = {
    componentWillMount() {
        this.props.fetchUsers( this.props.searchKey?this.props.searchKey:0, (this.props.paging && this.props.paging.number)?this.props.paging.number:"");
    }
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    lifecycle(lifecycleValue),
    withErrorComponent,
    withLoadingComponent
)(UserList);




// WEBPACK FOOTER //
// ./src/containers/UsersContainer.js